module.exports = __webpack_public_path__ + "img/EXTERIOR-BALENO-4.72918aea.jpg";